<p-dialog
    [visible]="visible"
    (visibleChange)="this.close()"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    appendTo="body"
    styleClass="skill-create-dialog"
    [style]="{'width': '680px', 'max-width': '95vw'}"
>
    <ng-template pTemplate="header">
        @if (!selectedType) {
        <span
            class="fw-bold"
            i18n="@@add-skill"
        >Skill hinzufügen</span>
        } @else {
        <div class="d-flex align-items-center gap-2">
            <p-button
                icon="ri ri-arrow-left-line"
                [text]="true"
                [plain]="true"
                size="small"
                (onClick)="this.back()"
            />
            <span class="fw-bold">
                <i [ngClass]="'ri-xl me-2 ' + selectedType.icon"></i>
                {{ selectedType.name }}
            </span>
        </div>
        }
    </ng-template>

    <!-- Step 1: Typ-Auswahl -->
    @if (!selectedType) {
    <p
        class="text-muted mb-3"
        i18n="@@select-skill-type"
    >Skills stellen dem KI-Modell gezielt Wissen bereit – genau dann, wenn es gebraucht wird. Wähle aus, welche
        Wissensquelle oder Funktion du hinzufügen möchtest.</p>
    <div class="skill-type-grid">
        @for (type of skillTypes; track type.toolId) {
        <div
            class="skill-type-card"
            (click)="this.selectType(type)"
        >
            <i [ngClass]="'ri-2x mb-2 ' + type.icon + ' text-primary'"></i>
            <span class="skill-type-name fw-semibold">{{ type.name }}</span>
            <span class="skill-type-desc text-muted small">{{ type.description }}</span>
        </div>
        }
    </div>
    }

    <!-- Step 2: Formular (Dokumente — Beschreibung + Projektdokument oder Upload) -->
    @if (selectedType && selectedType.formType === 'form-file') {
    <div class="d-flex flex-column gap-3">
        <div>
            <label
                class="form-label fw-semibold"
                i18n="@@skill-trigger-label"
            >Wann soll der Bot diesen Skill nutzen?</label>
            <textarea
                pTextarea
                class="w-100"
                [(ngModel)]="formDescription"
                rows="3"
                i18n-placeholder="@@description-placeholder"
                placeholder="Beschreibe typische Fragen oder Situationen, in denen der Bot diesen Skill einsetzen soll."
            ></textarea>
        </div>
        <div class="d-flex gap-2">
            <p-button
                i18n-label="@@select-from-project"
                label="Aus Projekt wählen"
                size="small"
                [outlined]="formFileMode !== 'project'"
                (onClick)="formFileMode = 'project'; formUploadFile = null"
            />
            <p-button
                i18n-label="@@upload-file"
                label="Datei hochladen"
                size="small"
                [outlined]="formFileMode !== 'upload'"
                (onClick)="formFileMode = 'upload'; formSelectedProjectDoc = null"
            />
        </div>
        @if (formFileMode === 'project') {
        @if (selectableDocsLoading) {
        <p
            class="text-muted small"
            i18n="@@project-docs-loading"
        >Laden…</p>
        } @else if (selectableDocuments.length === 0) {
        <p
            class="text-muted small"
            i18n="@@no-project-docs-hint"
        >Noch keine Projektdokumente vorhanden.</p>
        } @else {
        <p-select
            [options]="selectableDocuments"
            [(ngModel)]="formSelectedProjectDoc"
            optionLabel="filename"
            i18n-placeholder="@@select-document-placeholder"
            placeholder="Dokument auswählen"
            [filter]="true"
            filterBy="filename"
            styleClass="w-100"
            appendTo="body"
        />
        }
        }
        @if (formFileMode === 'upload') {
        <input
            type="file"
            class="form-control"
            (change)="onFileSelected($event)"
        />
        }
    </div>
    }

    <!-- Step 2: Formular (Name + URL, kein Description — z.B. Webhook) -->
    @if (selectedType && selectedType.formType === 'name-url') {
    <div class="d-flex flex-column gap-3">
        <div>
            <label
                class="form-label fw-semibold"
                i18n="@@name"
            >Name</label>
            <input
                pInputText
                class="w-100"
                [(ngModel)]="formName"
                i18n-placeholder="@@name-placeholder"
                placeholder="Name des Skills"
            />
        </div>
        <div>
            <label class="form-label fw-semibold">URL</label>
            <input
                pInputText
                class="w-100"
                [(ngModel)]="formUrl"
                type="url"
                placeholder="https://"
            />
        </div>
    </div>
    }

    <!-- Step 2: Formular (Beschreibung-basiert) -->
    @if (selectedType && (selectedType.formType === 'form' || selectedType.formType === 'form-url')) {
    <div class="d-flex flex-column gap-3">
        <div>
            <label
                class="form-label fw-semibold"
                i18n="@@skill-trigger-label"
            >Wann soll der Bot diesen Skill nutzen?</label>
            <textarea
                pTextarea
                class="w-100"
                [(ngModel)]="formDescription"
                rows="3"
                i18n-placeholder="@@description-placeholder"
                placeholder="Beschreibe typische Fragen oder Situationen, in denen der Bot diesen Skill einsetzen soll."
            ></textarea>
        </div>
        @if (selectedType.formType === 'form-url') {
        <div>
            <label class="form-label fw-semibold">URL</label>
            <input
                pInputText
                class="w-100"
                [(ngModel)]="formUrl"
                type="url"
                placeholder="https://"
            />
        </div>
        }
        @if (selectedType.toolId === 'websitescrape') {
        <div>
            <label
                class="form-label fw-semibold"
                i18n="@@page-depth-hint"
            >Gib hier die Seitentiefe ein, wie tief die Verlinkungen verfolgt werden sollen.</label>
            <p-inputnumber
                class="w-100"
                [min]="0"
                [max]="1"
                [step]="1"
                [(ngModel)]="formDepth"
                mode="decimal"
                fluid
            />
        </div>
        }
    </div>
    }

    <ng-template pTemplate="footer">
        @if (selectedType && selectedType.formType !== 'navigate') {
        <p-button
            i18n-label="@@cancel"
            label="Abbrechen"
            [text]="true"
            [plain]="true"
            (onClick)="this.close()"
        />
        <p-button
            i18n-label="@@create"
            label="Erstellen"
            icon="ri ri-add-line"
            [disabled]="!isFormValid || isCreating"
            [loading]="isCreating"
            (onClick)="this.create()"
        />
        }
    </ng-template>
</p-dialog>